import {useState, useEffect, Fragment} from 'react';
import {NavLink, useLocation, useHistory} from 'react-router-dom';

import {Button, Collapse, DropdownItem} from 'reactstrap';
import PublicNavActions from './PublicNavActions';

import cx from 'classnames';
import styles from './styles.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';

function PublicNavMobile(props) {
  const {navItems, hideMenu, utmProps} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [currentKey, setCurrentKey] = useState('auto');

  const location = useLocation();
  const currentPath = location.pathname;
  const history = useHistory();

  const handleClose = (e, to) => {
    e.preventDefault();
    setIsOpen(false);

    setTimeout(() => {
      history.push(to);
    }, 300);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setCurrentKey('auto');
    }
  }, [isOpen]);

  return (
    <div className="h-100">
      <Button
        color="light"
        className={cx(styles['dropdown__hamburger'], 'rounded')}
        onClick={() => setIsOpen(!isOpen)}
      >
        <MuiIcon name="menu" size="lg" />
      </Button>

      <nav
        className={cx(styles['dropdown__menu'], {
          [styles['dropdown__menu--close']]: !isOpen,
          [styles['dropdown__menu--open']]: isOpen,
        })}
      >
        <div className={styles['navigation__mobile']}>
          <div className="w-100 d-flex justify-content-end">
            <Button
              onClick={() => setIsOpen(false)}
              className={cx(styles['dropdown__close'], 'close')}
              color="link"
            >
              &times;
            </Button>
          </div>
          {navItems &&
            !hideMenu &&
            navItems.map((item, key) => {
              const {to, text} = item;
              const isParent = location.pathname.startsWith(item.parent);
              const isOpen =
                currentKey === key || (currentKey === 'auto' && isParent);
              if (!item.headers) {
                return (
                  <NavLink
                    to={to}
                    key={key}
                    href={to}
                    className={cx(
                      'font-weight-bold',
                      styles['dropdown__link'],
                      'p-0 mb-3',
                      {
                        [styles['dropdown__link--active']]: currentPath === to,
                      }
                    )}
                    color="link"
                    onClick={(e) => handleClose(e, to)}
                  >
                    {text}
                  </NavLink>
                );
              }

              return (
                <Fragment key={key}>
                  <div
                    onClick={() => {
                      if (isOpen) {
                        setCurrentKey(null);
                      } else {
                        setCurrentKey((prev) => (prev === key ? null : key));
                      }
                    }}
                    className={cx(
                      styles['dropdown__menu--group-toggle'],
                      'mb-3',
                      {
                        [styles['dropdown__link--active']]: false || isParent,
                      }
                    )}
                  >
                    {text}
                    <MuiIcon
                      name={isOpen ? 'expand_less' : 'expand_more'}
                      size="md"
                      className="cursor-pointer"
                    />
                  </div>
                  {item.headers.map((header, headerIndex) => {
                    return (
                      <div key={`${key}-${headerIndex}`}>
                        <Collapse
                          key={`${key}-${isOpen ? 'open' : 'closed'}`}
                          isOpen={isOpen}
                          className={cx(
                            styles['dropdown__menu--mobile'],
                            {
                              [styles['dropdown__menu--mobile-margin']]:
                                headerIndex !== item.headers.length - 1,
                            },
                            'mb-3'
                          )}
                        >
                          {header.header && (
                            <DropdownItem
                              header
                              className="font-weight-bold p-0"
                            >
                              {header.header}
                            </DropdownItem>
                          )}
                          {header.children.map((child, childIndex) => (
                            <NavLink
                              to={child.to}
                              key={childIndex}
                              className={cx(
                                styles['dropdown__link'],
                                styles['dropdown__link--mobile'],
                                'p-0 my-1 text-decoration-none',
                                {
                                  [styles['dropdown__link--active']]:
                                    currentPath === child.to,
                                }
                              )}
                              color="link"
                              onClick={(e) => handleClose(e, child.to)}
                            >
                              {child.text}
                            </NavLink>
                          ))}
                        </Collapse>
                      </div>
                    );
                  })}
                </Fragment>
              );
            })}
        </div>

        <PublicNavActions utmProps={utmProps} />
      </nav>
    </div>
  );
}

export default PublicNavMobile;
